import { GetPaymentWindowsResponseItem } from '../payment.types';

export class GetPaymentType {
  static readonly type = '[Payment] GetPaymentType';
}

export class ValidateStudentPayment {
  static readonly type = '[Payment] ValidateStudentPayment';
}

export class GetPaymentWindows {
  static readonly type = '[Payment] GetPaymentWindows';
}

export class GetStudentPaymentHistory {
  static readonly type = '[Payment] GetStudentPaymentHistory';
}

export class SubmitVoucherPayment {
  static readonly type = '[Payment] SubmitVoucherPayment';
  constructor(public code: string) {}
}

export class PayPalPaymentSubmitted {
  static readonly type = '[Payment] PayPalPaymentSubmitted';
  constructor(
    public paymentWindow: GetPaymentWindowsResponseItem,
    public paymentData: { orderID: any }
  ) {}
}
